import store from "../store";
import { actionTypes } from "./saga";

export function createPicture(data, asset) {
  store.dispatch({
    type: actionTypes.CREATE_PICTURE,
    payload: { data: data, asset: asset }
  });
}

export function editPicture(data, asset, documentId) {
  store.dispatch({
    type: actionTypes.EDIT_PICTURE,
    payload: { data: data, asset: asset, documentId: documentId }
  });
}

export function createDevice(data) {
  store.dispatch({
    type: actionTypes.CREATE_DEVICE,
    payload: { data: data }
  });
}

export function putReferencePicture(data) {
  store.dispatch({
    type: actionTypes.PUT_REFERENCE_PICTURE,
    payload: { data: data }
  });
}

export function getReferencePictureAsset(documentId) {
  store.dispatch({
    type: actionTypes.GET_REFERENCE_PICTURE_ASSETS,
    payload: { documentId: documentId }
  });
}

export function getSelectedEmployeePendingCaptures(employeeId) {
  store.dispatch({
    type: actionTypes.GET_PENDING_CAPTURES,
    payload: { employeeId }
  });
}

export function getSelectedEmployeeCapture(documentId) {
  store.dispatch({
    type: actionTypes.GET_EMPLOYEE_CAPTURED_PICTURE,
    payload: { documentId: documentId }
  });
}

export function getSelectedEmployeeCaptureAssets(currentPage, employeeId) {
  store.dispatch({
    type: actionTypes.GET_EMPLOYEE_CAPTURED_PICTURE_ASSETS,
    payload: { currentPage: currentPage, employeeId: employeeId }
  });
}

export function getPictureStatus(employeeId) {
  store.dispatch({
    type: actionTypes.GET_PICTURE_STATUS,
    payload: { employeeId: employeeId }
  });
}

export function putDevices(data) {
  store.dispatch({
    type: actionTypes.PUT_DEVICES,
    payload: { data: data }
  });
}

export function retryPictureUploadToDevices(documentId) {
  store.dispatch({
    type: actionTypes.RETRY_PICTURE_UPLOAD_TO_DEVICES,
    payload: { documentId: documentId }
  });
}

export function approveCapturePicture(data) {
  store.dispatch({
    type: actionTypes.APPROVE_CAPTURE_PICTURE,
    payload: data
  });
}

export function deleteReferencePicture(documentId) {
  store.dispatch({
    type: actionTypes.DELETE_REFERENCE_PICTURE,
    payload: {documentId}
  });
}

export function setLiveFeedAutoSwitchTime(time) {
  store.dispatch({
    type: actionTypes.SET_LIVE_FEED_AUTO_SWITCH_TIME,
    payload: {time}
  });
}
